// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/Background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Global Reset and Fonts ===== */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', sans-serif;
  }
  
  .login-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start; /* Align from the top */
    min-height: 100vh;
    padding-top: 8vh; /* Push it down from the top a bit */
    padding-left: 2rem;
    padding-right: 2rem;
   /*background: #f7f9fc; /* Light grayish-white */
   background: #f8fafc url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top center;
  }
  
  /* ===== Login Box ===== */
  .login {
    background: #ffffff;
    width: 100%;
    max-width: 640px;
    padding: 3rem 2rem;
    border-radius: 20px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: fadeInUp 0.8s ease-out;
  }
  
  /* ===== Header Text ===== */
  .login h2 {
    font-size: 2rem;
    font-weight: 700;
    color: #2b3c55;
    margin-bottom: 1rem;
  }
  
  .login p {
    font-size: 1rem;
    color: #4a4a4a;
    line-height: 1.6;
    margin-bottom: 2rem;
  }
  
  .login strong {
    color: #1a2c45;
  }
  
  /* ===== Logo Row ===== */
  .logo-row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 2.5rem;
  }
  
  .logo-row img {
    height: 80px;
    object-fit: contain;
    transition: transform 0.3s ease;
  }
  
  .logo-row img:hover {
    transform: scale(1.05);
  }
  
  /* ===== Sign-In Heading ===== */
  .login h4 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #2b3c55;
  }
  
  /* ===== Sign-In Button ===== */
  .btn {
    width: 100%;
    padding: 0.9rem 1rem;
    border-radius: 10px;
    background: #004080;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    margin-top: 1rem;
  }
  
  .btn:hover {
    background-color: #003060;
    transform: translateY(-1px);
  }
  
  /* ===== Footer Links ===== */
  .login nav {
    margin-top: 3rem;
  }
  
  .login nav a {
    color: #004080;
    font-size: 0.95rem;
    margin: 0 8px;
    text-decoration: none;
    font-weight: 500;
  }
  
  .login nav a:hover {
    text-decoration: underline;
  }
  

  .footer {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    color: #aaa;
    font-size: 0.85rem;
  }

  /* ===== Responsive Design ===== */
  @media (max-width: 768px) {
    .login {
      padding: 2rem;
    }
  
    .logo-row img {
      height: 60px;
    }
  
    .btn {
      font-size: 0.95rem;
    }
  }
  
  @media (max-width: 480px) {
    .login {
      padding: 1.5rem;
    }
  
    .login h2 {
      font-size: 1.5rem;
    }
  
    .logo-row img {
      height: 50px;
    }
  
    .btn {
      font-size: 0.9rem;
    }
  
    .login nav a {
      font-size: 0.85rem;
    }
  }
  

  @media (max-width: 768px) {
    .login-wrapper {
      padding-top: 6vh;
    }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/LogIn/LogIn.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB,EAAE,uBAAuB;IAChD,iBAAiB;IACjB,gBAAgB,EAAE,oCAAoC;IACtD,kBAAkB;IAClB,mBAAmB;GACpB,+CAA+C;GAC/C,sEAAoE;EACrE;;EAEA,0BAA0B;EAC1B;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,2DAA2D;IAC3D,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,6BAA6B;EAC7B;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE;MACE,aAAa;IACf;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;;;EAGA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":["/* ===== Global Reset and Fonts ===== */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Segoe UI', sans-serif;\n  }\n  \n  .login-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start; /* Align from the top */\n    min-height: 100vh;\n    padding-top: 8vh; /* Push it down from the top a bit */\n    padding-left: 2rem;\n    padding-right: 2rem;\n   /*background: #f7f9fc; /* Light grayish-white */\n   background: #f8fafc url('../../img/Background-login.png') top center;\n  }\n  \n  /* ===== Login Box ===== */\n  .login {\n    background: #ffffff;\n    width: 100%;\n    max-width: 640px;\n    padding: 3rem 2rem;\n    border-radius: 20px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    animation: fadeInUp 0.8s ease-out;\n  }\n  \n  /* ===== Header Text ===== */\n  .login h2 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #2b3c55;\n    margin-bottom: 1rem;\n  }\n  \n  .login p {\n    font-size: 1rem;\n    color: #4a4a4a;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n  }\n  \n  .login strong {\n    color: #1a2c45;\n  }\n  \n  /* ===== Logo Row ===== */\n  .logo-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-bottom: 2.5rem;\n  }\n  \n  .logo-row img {\n    height: 80px;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n  }\n  \n  .logo-row img:hover {\n    transform: scale(1.05);\n  }\n  \n  /* ===== Sign-In Heading ===== */\n  .login h4 {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    color: #2b3c55;\n  }\n  \n  /* ===== Sign-In Button ===== */\n  .btn {\n    width: 100%;\n    padding: 0.9rem 1rem;\n    border-radius: 10px;\n    background: #004080;\n    color: #ffffff;\n    font-size: 1rem;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    margin-top: 1rem;\n  }\n  \n  .btn:hover {\n    background-color: #003060;\n    transform: translateY(-1px);\n  }\n  \n  /* ===== Footer Links ===== */\n  .login nav {\n    margin-top: 3rem;\n  }\n  \n  .login nav a {\n    color: #004080;\n    font-size: 0.95rem;\n    margin: 0 8px;\n    text-decoration: none;\n    font-weight: 500;\n  }\n  \n  .login nav a:hover {\n    text-decoration: underline;\n  }\n  \n\n  .footer {\n    position: absolute;\n    bottom: 10px;\n    width: 100%;\n    text-align: center;\n    color: #aaa;\n    font-size: 0.85rem;\n  }\n\n  /* ===== Responsive Design ===== */\n  @media (max-width: 768px) {\n    .login {\n      padding: 2rem;\n    }\n  \n    .logo-row img {\n      height: 60px;\n    }\n  \n    .btn {\n      font-size: 0.95rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .login {\n      padding: 1.5rem;\n    }\n  \n    .login h2 {\n      font-size: 1.5rem;\n    }\n  \n    .logo-row img {\n      height: 50px;\n    }\n  \n    .btn {\n      font-size: 0.9rem;\n    }\n  \n    .login nav a {\n      font-size: 0.85rem;\n    }\n  }\n  \n\n  @media (max-width: 768px) {\n    .login-wrapper {\n      padding-top: 6vh;\n    }\n  }\n  \n  @keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(40px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
